import {
  Branch as BaseBranch,
  PullRequest,
  Commit,
} from 'src/components/types';
import { BRANCH_KIND } from 'src/constants/branching-model';
import { BuildStatusesMap } from 'src/types';
import { MergeStrategy, SyncStrategy } from 'src/types/pull-request';

export type BranchPermission = 'allow' | 'deny';

export type BranchPermissions = {
  push: BranchPermission;
  delete: BranchPermission;
};

// The commit on the branch is missing several fields that are
// required on the `Commit` type
type DetailedBranchTarget = Pick<Commit, 'date' | 'hash' | 'type'> & {
  links: Pick<Commit['links'], 'self' | 'html'>;
  author: Omit<Commit['author'], 'type'>;
};

export type DetailedBranchPullRequest = Pick<
  PullRequest,
  'closed_on' | 'title' | 'created_on' | 'state' | 'type' | 'id' | 'draft'
> & {
  links: Pick<PullRequest['links'], 'self' | 'html'>;
};

export type DetailedBranch = Omit<BaseBranch, 'target'> & {
  ahead: number | null | undefined;
  behind: number | null | undefined;
  branchtype: BRANCH_KIND;
  isMainBranch: boolean;
  pullRequests: DetailedBranchPullRequest[];
  pullRequestsTargetedCount: number;
  target: DetailedBranchTarget;
  status_counts: BuildStatusesMap;
  permissions: BranchPermissions;
  default_merge_strategy?: MergeStrategy;
  merge_strategies?: MergeStrategy[];
  sync_strategies?: SyncStrategy[];
};

export type BranchingModelBranch = {
  name: string;
  use_mainbranch: boolean;
  type: string;
  target?: {
    hash: string;
  };
};

export type Sort =
  | 'name'
  | 'ahead'
  | 'behind'
  | 'target.date'
  | '-name'
  | '-ahead'
  | '-behind'
  | '-target.date';

export enum Status {
  Active = 'active',
  Merged = 'merged',
  All = 'all',
  Stale = 'stale',
}

export type BranchType = {
  kind: BRANCH_KIND;
  prefix: string;
};

export type BranchingModel = {
  branchTypes: BranchType[];
};

// Note that these properties are mapped directly to query params,
// so changing them would mean breaking existing URLs
export type Filter = {
  status: Status;
  search: string;
  branchtype: BRANCH_KIND[];
};

export type Params = Filter & {
  sort: Sort;
  page: number;
};
